import React from 'react';
import customHeaders, { getSpace } from '../../common/headers';
import { useState, useEffect } from 'react';
import { useRef } from 'react';
import { DropDownSelector, TableBox, ButtonBasic } from '@lk-gtcom/ecomlab-components';
import { FilterContainer } from '../../components/FilterContainer/FilterContainer';
import { OlegHttps } from '../../fetchUrls';
import { useDataTable } from '../../common/hooks';
import { TitlePage } from '../../components/TitlePage/TitlePage';
import { options_prop_mp } from '../../common/globalVariables';
import useGeneralStore from '../../store/general';
import { fetchApiFilterVer3 } from '../../common/filtersFunc';
import { ModalCreateCampaignFromRules } from './Modal/ModalCreateCampaignFromRules';
import { ModalLaunchHistory } from './Modal/ModalLaunchHistory/ModalLaunchHistory';
import { getValueMultiFilter } from '../../common/filtersFunc';
import { RequestController } from '../../common/filtersFunc';
import { useURLSearchParams } from '../../common/useURLSearchParams';
import ModalWarning from '../../components/Modal/ModalWarning/ModalWarning';
import { useResponseHandler } from '../../common/auth';
import { useSavedFilters } from '../../common/useSavedFilters';
import "./CreateCampaignFromRules.scss"


const CreateCampaignFromRules = ({ }) => {
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };
    // Сохранённые фильтры: подставляются в URL при заходе, запись по кнопке
    const { isReady, saveFilters, clearSavedFilters, isSaved, hasSavedFilters } = useSavedFilters(selectedSpace?.value, 'create-campaign-from-rules');
    const { handleStatusCode, handleTableResponse, handleRequestError } = useResponseHandler();
    // Реф для хранения контроллера запросов
    const requestControllerRef = useRef(new RequestController());

    // Фильтры
    const filterConfig = [
        { key: 'mp', type: 'multi' },
        { key: 'api', type: 'multi' }
    ];
    const { urlParams, updateURL, isInitialized, hasInitialParams } = useURLSearchParams(filterConfig);
    const [isFilterRequest, setIsFilterRequest] = useState(false);

    const [selectedMp, setSelectedMp] = useState([{ label: 'Все', value: 'all' }]);
    const [selectedApi, setSelectedApi] = useState([{ label: 'Все', value: 'all' }]);
    const [apiData, setApiData] = useState([]);
    const [apiPage, setApiPage] = useState(1);
    const [apiQuery, setApiQuery] = useState('');
    const [totalApi, setTotalApi] = useState(0);

    // Таблица
    const [isTableRequest, setIsTableRequest] = useState(false);
    const paginatorRef = useRef();
    const [setTable, tableProps, setTableFuncs] = useDataTable(paginatorRef.current?.setTotal, paginatorRef);
    const { setLoading, setFetchedData, setHeaders, setSort } = setTableFuncs;

    // Modal
    const [isModal, setIsModal] = useState(false)
    const [isModalConfirm, setIsModalConfirm] = useState(false)
    const [isModalLaunchHistory, setIsModalLaunchHistory] = useState(false)
    const [currentСampaign, setCurrentСampaign] = useState(null)
    const [currentСampaignId, setCurrentСampaignId] = useState(null)

    // Инициализация фильтров из URL параметров при первом рендере
    const [isInitialLoadFromURL, setIsInitialLoadFromURL] = useState(false);

    useEffect(() => {
        if (!isReady) return;
        if (!isInitialLoadFromURL) {
            setIsInitialLoadFromURL(true);

            // Обновляем все состояния фильтров
            setTimeout(() => {
                if (urlParams.mp) setSelectedMp(urlParams.mp)
                if (urlParams.api) setSelectedApi(urlParams.api)

                // Запускаем запрос таблицы и фильтров только при первой инициализации из URL
                setIsFilterRequest(prev => !prev);
                if (Object.keys(urlParams).length > 0) {
                    setIsTableRequest(prev => !prev);
                }
            }, 10);
        }
    }, [urlParams, isReady]);

    useEffect(() => {
        if (!isReady) return;
        updateURL({
            mp: urlParams?.mp || selectedMp,
            api: urlParams?.api || selectedApi
        })
    }, [isReady]);

    const contextMenuArr = [
        {
            label: 'История запусков',
            onClick: (e) => {
                setCurrentСampaignId(e?.uid)
                setIsModalLaunchHistory(true)
            }
        },
        {
            label: 'Удалить',
            onClick: (e) => {
                setCurrentСampaignId(e?.uid)
                setIsModalConfirm(true)
            }
        },
    ];

    //Фильтры
    const apiFilter = () => {
        const controller = requestControllerRef.current.createController('api');

        fetchApiFilterVer3({
            controller,
            selectedSpace: selectedSpace?.value,
            page: apiPage,
            setApiData: setApiData,
            set: setApiData,
            searchParam: apiQuery,
            selectedApi,
            selectedShop: selectedMp,
            filter: 'api_id',
            setTotal: setTotalApi
        })?.finally(() => {
            requestControllerRef.current.removeController('api');
        })
    };

    useEffect(() => {
        if (!isInitialLoadFromURL) return;
        apiFilter();
    }, [apiPage, apiQuery, isFilterRequest]);

    useEffect(() => {
        return () => {
            // Отменяем все активные запросы фильтров
            requestControllerRef.current.abortAll();
        };
    }, []);

    // Таблица
    const fetchTableData = (params, abortController = new AbortController()) => {
        setLoading(true);

        let sort, filtersParam;
        if (params) {
            [sort, filtersParam] = params;
        }

        const url = `${OlegHttps}/api/v1/strategies/show${sort?.length > 0
            ? '?order_param=' + sort[0] + '&order_param_direction=' + sort[1]
            : ''
            }`;

        const body = JSON.stringify({
            filters: filtersParam,
            page: paginatorRef.current.page,
            limit: paginatorRef.current.limit,
            api_id_list: getValueMultiFilter(selectedApi),
            mp_id_list: getValueMultiFilter(selectedMp)
        });

        fetch(url, { method: 'POST', headers, body, signal: abortController.signal })
            .then(handleTableResponse)
            .then((json) => setTable(json))
            .catch(handleRequestError)
            .finally(() => {
                if (abortController?.signal.aborted) return
                setLoading(false)
            });
    };

    // Удаление кампании
    const fetchDeleteСampaign = (id, selected) => {
        let url = `https://apps1.ecomru.ru:4450/api/v1/campaign/delete${selected ? `?delete_option=${selected}` : ''}`

        const body = JSON.stringify({
            id: id
        });

        fetch(url, { body, method: 'DELETE', headers })
            .then((res) => {
                if (res.ok) {
                    setTimeout(() => fetchTableData(), 500)
                    return res.json();
                } else {
                    throw Error(JSON.stringify(res.json()));
                }
            })
            .then((json) => { })
            .catch(handleRequestError);
    }

    useEffect(() => {
        if (!isReady) return;
        if (!isModal) {
            const abortController = new AbortController();
            fetchTableData([], abortController);
            return () => abortController.abort();
        }
    }, [isModal, isTableRequest]);

    // Получение всех параметров кампании
    const fetchGetСampaignInfo = (id) => {
        let url = `https://apps1.ecomru.ru:4450/api/v1/show/attr?uid=${id}`

        fetch(url, { method: 'GET', headers })
            .then(handleTableResponse)
            .then((json) => {
                setCurrentСampaign(json)
                setIsModal(true)
            })
            .catch(handleRequestError);
    }

    const onActionHandler = (e) => {
        const { uid } = e
        fetchGetСampaignInfo(uid)
    }

    // Модалка warning
    const [selected, setSelected] = useState(null);

    const options = [
        { value: "Удалить изменения", label: "Удалить изменения" },
        { value: "Оставить текущие ставки", label: "Оставить текущие ставки" }
    ];

    const handleChange = (value) => {
        setSelected(value);
    };

    return (
        <>
            {isModal && <ModalCreateCampaignFromRules
                setIsModal={(e) => setIsModal(e)}
                currentСampaign={currentСampaign}
                setCurrentСampaign={setCurrentСampaign}
            />}

            {/* История запусков */}
            {isModalLaunchHistory && <ModalLaunchHistory
                setIsModal={setIsModalLaunchHistory}
                currentСampaignId={currentСampaignId}
                setCurrentСampaignId={setCurrentСampaignId}
            />}

            {/* Подтверждение удаления*/}
            {isModalConfirm && <ModalWarning
                headerText='Подтвердите удаление'
                colorBtn={'red'}
                cancelButtonText='Отменить'
                approveButtonText='Удалить'
                onCancelClick={() => {
                    setCurrentСampaignId(null)
                    setSelected(null)
                    setIsModalConfirm(false)
                }}
                onApproveClick={() => {
                    fetchDeleteСampaign(currentСampaignId, selected)
                    setCurrentСampaignId(null)
                    setSelected(null)
                    setIsModalConfirm(false)
                }}
                disabledApprove={!selected}
                children={
                    <div className='repricing__options'>
                        {
                            options.map((option) => (
                                <label key={option.value}>
                                    <input
                                        type="radio"
                                        name="price"
                                        value={option.value}
                                        checked={selected === option.value}
                                        onChange={() => handleChange(option.value)}
                                    />
                                    {option.label}
                                </label>
                            ))
                        }
                    </div>
                }
            />}

            <div className='create-campaign-from-rules'>
                <TitlePage
                    title='Cоздать кампанию из правил'
                />
                <FilterContainer
                    loading={isSaved}
                    saveFilters={saveFilters}
                    clearSavedFilters={clearSavedFilters}
                    hasSavedFilters={hasSavedFilters}
                    onReset={(e) => {
                        setSelectedMp([]);
                        setSelectedApi([]);
                        updateURL({
                            mp: null,
                            api: null
                        });
                        setIsTableRequest(!isTableRequest)
                        setIsFilterRequest(!isFilterRequest)
                    }}
                >
                    <DropDownSelector
                        options_prop={options_prop_mp}
                        state={selectedMp}
                        setState={setSelectedMp}
                        placeholder="Маркетплейс"
                        total={options_prop_mp?.length}
                        multi
                        onBlur={() => {
                            updateURL({ mp: selectedMp });
                            apiFilter()
                            setIsTableRequest(!isTableRequest)
                        }}
                    />

                    <DropDownSelector
                        options_prop={apiData}
                        state={selectedApi}
                        setState={setSelectedApi}
                        placeholder="Площадка"
                        total={totalApi}
                        fetchCallback={setApiPage}
                        setInputChange={setApiQuery}
                        multi
                        onBlur={() => {
                            updateURL({ api: selectedApi });
                            setIsTableRequest(!isTableRequest)
                        }}
                    />
                </FilterContainer>

                <TableBox
                    {...tableProps}
                    fetchCallback={(e) => fetchTableData(e)}
                    ref={paginatorRef}
                    paginator={true}
                    child={
                        <ButtonBasic
                            onClick={(e) => setIsModal(true)}
                            green
                            text='Cоздать кампанию'
                            size='32px'
                        />
                    }
                    onAction={onActionHandler}
                    contextMenuArr={contextMenuArr}
                />
            </div>
        </>
    )
}

export { CreateCampaignFromRules }